/**
 * InfinitSales - Inbox do Widget do site (5o canal, 2026-09-23)
 *
 * Wrapper fino sobre o shell COMPARTILHADO do inbox: toda a fiacao do canal
 * mora no adaptador (components/inbox/channelAdapters/widget.js). Nasceu como
 * adaptador, nao como 5a copia (D5 do prompt de 22/09).
 */
import React from 'react';
import ChannelInbox from '../../components/inbox/Inbox';
import widgetAdapter from '../../components/inbox/channelAdapters/widget';

const WidgetInbox = () => <ChannelInbox adapter={widgetAdapter} />;

export default WidgetInbox;
